import { Loader2, Sparkles } from "lucide-react";
import { useLoyaltyPointsPreview } from "../api/queries";
import type { LoyaltyPreviewItem } from "../lib/loyalty-preview-items";

type Props = {
  customerId?: string | null;
  items: LoyaltyPreviewItem[];
  enabled?: boolean;
  className?: string;
};

export function LoyaltyPointsPreview({
  customerId,
  items,
  enabled = true,
  className,
}: Props) {
  const preview = useLoyaltyPointsPreview(customerId, items, enabled);

  if (!customerId) {
    return null;
  }

  if (items.length === 0) {
    return null;
  }

  if (preview.isLoading || preview.isFetching) {
    return (
      <div
        className={`flex items-center gap-2 rounded-md border border-border/60 bg-muted/40 px-3 py-2 text-muted-foreground text-sm ${className ?? ""}`}
      >
        <Loader2 className="h-4 w-4 animate-spin" />
        <span>ກຳລັງຄິດຄະແນນສະສົມ...</span>
      </div>
    );
  }

  const points = preview.data?.points ?? 0;

  if (points <= 0) {
    return (
      <div
        className={`rounded-md border border-border/60 bg-muted/30 px-3 py-2 text-muted-foreground text-sm ${className ?? ""}`}
      >
        ບໍ່ມີຄະແນນສະສົມຈາກລາຍການນີ້
      </div>
    );
  }

  return (
    <div
      className={`flex items-center gap-2 rounded-md border border-amber-200/80 bg-amber-50 px-3 py-2 text-amber-950 dark:border-amber-900/50 dark:bg-amber-950/30 dark:text-amber-100 ${className ?? ""}`}
    >
      <Sparkles className="h-4 w-4 shrink-0" />
      <span className="text-sm">
        ຈະໄດ້ຮັບ{" "}
        <span className="font-semibold tabular-nums">
          {points.toLocaleString("lo-LA")}
        </span>{" "}
        ຄະແນນ
        {preview.data?.ruleName ? (
          <span className="text-muted-foreground"> ({preview.data.ruleName})</span>
        ) : null}
      </span>
    </div>
  );
}
